import React, { Component } from 'react';

import { showSearch } from '../actions/search';

const Place = ({ label, value, type, dispatch }) => {
    const className = `Place ${value !== '' ? 'is-filled' : ''}`;
    return (
        <div className={className} onClick={() => dispatch(showSearch(value, label, type))}>
            <div className="Place-label">{label}</div>
            <div className="Place-value">{value}</div>
        </div>
    )
}

export default Place


// WEBPACK FOOTER //
// ./components/Place.js